/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Origin_Feature_4Inputs */

const en_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-time purchase can be activated multiple times across all your devices`)
};

const id_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembelian sekali bayar dapat diaktifkan beberapa kali di seluruh device Anda`)
};

const ms_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembelian sekali boleh diaktifkan berbilang kali merentas semua peranti anda`)
};

const ca_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La compra única es pot activar diverses vegades en tots els teus aparells`)
};

const cs_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jednorázový nákup lze aktivovat vícekrát na všech vašich zařízeních`)
};

const da_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engangskøb kan aktiveres flere gange på tværs af alle dine enheder`)
};

const de_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einmaliger Kauf kann mehrfach auf all deinen Geräten aktiviert werden`)
};

const et_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ühekordse ostu saab aktiveerida mitu korda kõigis sinu seadmetes`)
};

const es_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La compra única se puede activar varias veces en todos tus dispositivos`)
};

const fr_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’achat unique peut être activé plusieurs fois sur tous vos appareils`)
};

const hr_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jednokratna kupnja može se aktivirati više puta na svim vašim uređajima`)
};

const it_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'acquisto una tantum può essere attivato più volte su tutti i tuoi device`)
};

const lv_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vienreizēju pirkumu var aktivizēt vairākas reizes visās jūsu ierīcēs`)
};

const lt_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vienkartinis pirkinys gali būti aktyvuojamas kelis kartus visuose jūsų įrenginiuose`)
};

const hu_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az egyszeri vásárlás többször is aktiválható az összes eszközödön`)
};

const nl_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eenmalige aankoop kan meerdere keren worden geactiveerd op al je devices`)
};

const nb_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engangskjøp kan aktiveres flere ganger på tvers av alle enhetene dine`)
};

const pl_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakup jednorazowy można aktywować wielokrotnie na wszystkich urządzeniach`)
};

const pt_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A compra única pode ser ativada várias vezes em todos os seus dispositivos`)
};

const ro_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achiziția unică poate fi activată de mai multe ori pe toate dispozitivele tale`)
};

const sk_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jednorazový nákup je možné aktivovať viackrát na všetkých vašich zariadeniach`)
};

const sl_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enkratni nakup je mogoče aktivirati večkrat na vseh vaših napravah`)
};

const fi_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kertaluonteinen osto voidaan aktivoida useita kertoja kaikilla laitteillasi`)
};

const sv_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engångsköp kan aktiveras flera gånger på alla dina enheter`)
};

const vi_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mua một lần có thể được kích hoạt nhiều lần trên tất cả các thiết bị của bạn`)
};

const tr_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek seferlik satın alma, tüm cihazlarınızda birden çok kez etkinleştirilebilir`)
};

const el_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η εφάπαξ αγορά μπορεί να ενεργοποιηθεί πολλές φορές σε όλες τις συσκευές σας`)
};

const bg_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Еднократната покупка може да бъде активирана многократно на всички ваши устройства`)
};

const ru_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разовая покупка, которую можно активировать несколько раз на всех ваших устройствах`)
};

const sr_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Једнократна куповина се може активирати више пута на свим вашим уређајима`)
};

const uk_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одноразову покупку можна активувати кілька разів на всіх ваших пристроях`)
};

const ka_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ერთჯერადი შეძენის გააქტიურება შესაძლებელია მრავალჯერ თქვენს ყველა მოწყობილობაზე`)
};

const hi_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक बार की खरीद को आपके सभी डिवाइसों पर कई बार सक्रिय किया जा सकता है`)
};

const th_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การซื้อแบบครั้งเดียวสามารถเปิดใช้งานได้หลายครั้งบนอุปกรณ์ทั้งหมดของคุณ`)
};

const ko_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일회성 구매로 모든 디바이스에서 여러 번 활성화 가능`)
};

const zh_tw_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次性購買可在您的所有裝置上多次啟用`)
};

const ja_origin_feature_4 = /** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`買い切り購入で、すべてのデバイスで複数回アクティベート可能`)
};

/** @type {(inputs: Origin_Feature_4Inputs) => LocalizedString} */
const zh_origin_feature_4 = en_origin_feature_4;

/**
* | output |
* | --- |
* | "One-time purchase can be activated multiple times across all your devices" |
*
* @param {Origin_Feature_4Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const origin_feature_4 = /** @type {((inputs?: Origin_Feature_4Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Origin_Feature_4Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_origin_feature_4(inputs)
	if (locale === "ms") return ms_origin_feature_4(inputs)
	if (locale === "ca") return ca_origin_feature_4(inputs)
	if (locale === "cs") return cs_origin_feature_4(inputs)
	if (locale === "da") return da_origin_feature_4(inputs)
	if (locale === "de") return de_origin_feature_4(inputs)
	if (locale === "et") return et_origin_feature_4(inputs)
	if (locale === "es") return es_origin_feature_4(inputs)
	if (locale === "fr") return fr_origin_feature_4(inputs)
	if (locale === "hr") return hr_origin_feature_4(inputs)
	if (locale === "it") return it_origin_feature_4(inputs)
	if (locale === "lv") return lv_origin_feature_4(inputs)
	if (locale === "lt") return lt_origin_feature_4(inputs)
	if (locale === "hu") return hu_origin_feature_4(inputs)
	if (locale === "nl") return nl_origin_feature_4(inputs)
	if (locale === "nb") return nb_origin_feature_4(inputs)
	if (locale === "pl") return pl_origin_feature_4(inputs)
	if (locale === "pt") return pt_origin_feature_4(inputs)
	if (locale === "ro") return ro_origin_feature_4(inputs)
	if (locale === "sk") return sk_origin_feature_4(inputs)
	if (locale === "sl") return sl_origin_feature_4(inputs)
	if (locale === "fi") return fi_origin_feature_4(inputs)
	if (locale === "sv") return sv_origin_feature_4(inputs)
	if (locale === "vi") return vi_origin_feature_4(inputs)
	if (locale === "tr") return tr_origin_feature_4(inputs)
	if (locale === "el") return el_origin_feature_4(inputs)
	if (locale === "bg") return bg_origin_feature_4(inputs)
	if (locale === "ru") return ru_origin_feature_4(inputs)
	if (locale === "sr") return sr_origin_feature_4(inputs)
	if (locale === "uk") return uk_origin_feature_4(inputs)
	if (locale === "ka") return ka_origin_feature_4(inputs)
	if (locale === "hi") return hi_origin_feature_4(inputs)
	if (locale === "th") return th_origin_feature_4(inputs)
	if (locale === "ko") return ko_origin_feature_4(inputs)
	if (locale === "zh") return zh_origin_feature_4(inputs)
	if (locale === "zh-tw") return zh_tw_origin_feature_4(inputs)
	if (locale === "ja") return ja_origin_feature_4(inputs)
	return en_origin_feature_4(inputs)
});